import { render, staticRenderFns } from "./mobileInterstitial.vue?vue&type=template&id=2c81e65c&scoped=true&"
import script from "./mobileInterstitial.vue?vue&type=script&lang=js&"
export * from "./mobileInterstitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81e65c",
  null
  
)

export default component.exports